import apiClient from "../../client/apiClient"

// Developmental checklist (FY1 Eon) — deliberately separate service/types
// from marks-entry, since this isn't a marks-based feature at all.

export type RubricItem = {
  _id: string
  description: string
  type: "checkbox" | "rating"
}

export type RubricSubcategory = {
  _id: string
  name: string
  items: RubricItem[]
}

export type RubricCategory = {
  _id: string
  name: string
  subcategories: RubricSubcategory[]
}

export type RubricTemplate = {
  _id: string
  class: string
  branch: string
  title: string
  categories: RubricCategory[]
}

export type RubricWorkItem = {
  templateId: string
  templateTitle: string
  classId: string
  className: string
  sectionId: string
  sectionName: string
  studentCount: number
  breakdowns: { id: string; title: string }[]
}

// "check" | "cross" | null (unanswered) for checkbox items; 1-4 | null for rating items.
export type RubricValue = "check" | "cross" | 1 | 2 | 3 | 4 | null

export type RubricResponseEntry = { itemId: string; value: RubricValue }

export type RubricStudentRow = {
  enrollmentId: string
  grNo: string
  studentName: string
  responses: RubricResponseEntry[]
  remarks: string
}

const BASE = "/rubric"

export const getRubricWorkItems = async (session: string): Promise<{ success: boolean; data: RubricWorkItem[] }> => {
  const res = await apiClient({ method: "GET", url: `${BASE}/me/work-items`, params: { session } })
  return res.data
}

export const getRubricGrid = async (params: {
  template: string
  section: string
  breakdown: string
}): Promise<{ success: boolean; data: { template: RubricTemplate; students: RubricStudentRow[] } }> => {
  const res = await apiClient({ method: "GET", url: `${BASE}/me/grid`, params })
  return res.data
}

export const saveRubricResponse = async (data: {
  enrollmentId: string
  templateId: string
  breakdownId: string
  responses: RubricResponseEntry[]
  remarks: string
}): Promise<{ success: boolean }> => {
  const res = await apiClient({ method: "POST", url: `${BASE}/me/save`, data })
  return res.data
}
